// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getBlogDetail } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const getBlogDetailListData = createAsyncThunk(
  "getBlogDetailListData",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        //   Authorization: `${localStorage.getItem("professionalToken")}`,
        },
        params: payload
      };
      const url = ApiBaseUrl + getBlogDetail;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const BlogDetailSlice = createSlice({
  name: "getBlogDetailReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearBlogData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBlogDetailListData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBlogDetailListData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getBlogDetailListData.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearBlogData } = BlogDetailSlice.actions;
export default BlogDetailSlice.reducer;
